import { useNavigate } from 'react-router-dom';

const useEventsClick = () => {
  const navigate = useNavigate();

  const handleClickUrl = (event) => {
    if (!event?.link?.url) return;
    window.open(event?.link?.url, '_blank');
  };

  const handleClickService = (event) => {
    if (!event?.link?.service) return;
    navigate(`./service/${event?.link?.service}`);
  };

  const handleClickCategory = (event) => {
    if (!event?.link?.category) return;
    navigate(`./category/${event?.link?.category}`);
  };

  const handleClickProduct = (event) => {
    if (!event?.link?.product) return;
    navigate(`./product/${event?.link?.product}`);
  };

  const handleNoClick = () => null;

  const clickHandler = (type, event) => {
    switch (type) {
      case 'url':
        return () => handleClickUrl(event);

      case 'service':
        return () => handleClickService(event);

      case 'category':
        return () => handleClickCategory(event);

      case 'product':
        return () => handleClickProduct(event);

      default:
        return handleNoClick;
    }
  };

  return { clickHandler };
};

export default useEventsClick;
